var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [
            _vm._v("线索计划基本信息"),
          ]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "线索计划名称",
                    "label-col": { span: 3 },
                    "wrapper-col": { span: 21 },
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: [
                          "planName",
                          {
                            rules: [
                              { required: true, message: "请输入线索计划名称" },
                            ],
                          },
                        ],
                        expression:
                          "['planName', { rules: [{ required: true, message: '请输入线索计划名称' }] }]",
                      },
                    ],
                    attrs: { disabled: _vm.index != 0, maxLength: 50 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "线索时间",
                        "label-col": { span: 9 },
                        "wrapper-col": { span: 10 },
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "planTimeType",
                                {
                                  rules: [
                                    { required: true, message: "请选择时间" },
                                  ],
                                },
                              ],
                              expression:
                                "['planTimeType', { rules: [{ required: true, message: '请选择时间' }] }]",
                            },
                          ],
                          attrs: { disabled: _vm.index != 0 },
                          on: { change: _vm.onChange },
                        },
                        [
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v(" 季度 "),
                          ]),
                          _c("a-radio", { attrs: { value: 2 } }, [
                            _vm._v(" 月度 "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "年份",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 8 },
                      },
                    },
                    [
                      _c("a-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "planYear",
                              {
                                rules: [
                                  { required: true, message: "请选择年份" },
                                ],
                              },
                            ],
                            expression:
                              "['planYear',{ rules: [{ required: true, message: '请选择年份' }] }]",
                          },
                        ],
                        attrs: {
                          allowClear: true,
                          disabled: _vm.index != 0,
                          options: _vm.planTimeOptions,
                        },
                        on: { change: _vm.getYear },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.years || _vm.isShowMonths
                ? _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.label,
                            "label-col": { span: 4 },
                            "wrapper-col": { span: 8 },
                          },
                        },
                        [
                          _c("a-select", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "planMonth",
                                  {
                                    rules: [
                                      { required: true, message: "请选择" },
                                    ],
                                  },
                                ],
                                expression:
                                  "['planMonth',{ rules: [{ required: true, message: '请选择' }] }]",
                              },
                            ],
                            attrs: {
                              allowClear: true,
                              disabled: _vm.index != 0,
                              options: _vm.planMonthOptions,
                            },
                            on: { change: _vm.getMonth },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.index == 1
            ? _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "牵引数量",
                        "label-col": { span: 3 },
                        "wrapper-col": { span: 4 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "qyNum",
                              {
                                rules: [
                                  { required: true, message: "请输入牵引数量" },
                                ],
                              },
                            ],
                            expression:
                              "['qyNum', { rules: [{ required: true, message: '请输入牵引数量' }] }]",
                          },
                        ],
                        attrs: {
                          disabled: _vm.index != 0,
                          default: "0",
                          maxLength: 18,
                          type: "number",
                          min: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.index == 1
            ? _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "载货数量",
                        "label-col": { span: 3 },
                        "wrapper-col": { span: 4 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "zhNum",
                              {
                                rules: [
                                  { required: true, message: "请输入载货数量" },
                                ],
                              },
                            ],
                            expression:
                              "['zhNum', { rules: [{ required: true, message: '请输入载货数量' }] }]",
                          },
                        ],
                        attrs: {
                          disabled: _vm.index != 0,
                          default: "0",
                          maxLength: 18,
                          type: "number",
                          min: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.index == 1
            ? _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "工程数量",
                        "label-col": { span: 3 },
                        "wrapper-col": { span: 4 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "gcNum",
                              {
                                rules: [
                                  { required: true, message: "请输入工程数量" },
                                ],
                              },
                            ],
                            expression:
                              "['gcNum', { rules: [{ required: true, message: '请输入工程数量' }] }]",
                          },
                        ],
                        attrs: {
                          disabled: _vm.index != 0,
                          default: "0",
                          maxLength: 18,
                          type: "number",
                          min: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.index == 1
            ? _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "专用数量",
                        "label-col": { span: 3 },
                        "wrapper-col": { span: 4 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "zyNum",
                              {
                                rules: [
                                  { required: true, message: "请输入专用数量" },
                                ],
                              },
                            ],
                            expression:
                              "['zyNum', { rules: [{ required: true, message: '请输入专用数量' }] }]",
                          },
                        ],
                        attrs: {
                          disabled: _vm.index != 0,
                          default: "0",
                          maxLength: 18,
                          type: "number",
                          min: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.index == 1
            ? _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "轻卡数量",
                        "label-col": { span: 3 },
                        "wrapper-col": { span: 4 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "qkNum",
                              {
                                rules: [
                                  { required: true, message: "请输入轻卡数量" },
                                ],
                              },
                            ],
                            expression:
                              "['qkNum', { rules: [{ required: true, message: '请输入轻卡数量' }] }]",
                          },
                        ],
                        attrs: {
                          disabled: _vm.index != 0,
                          default: "0",
                          maxLength: 18,
                          type: "number",
                          min: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.index == 1
            ? _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "新能源数量",
                        "label-col": { span: 3 },
                        "wrapper-col": { span: 4 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "xnyNum",
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: "请输入新能源数量",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "['xnyNum', { rules: [{ required: true, message: '请输入新能源数量' }] }]",
                          },
                        ],
                        attrs: {
                          disabled: _vm.index != 0,
                          default: "0",
                          maxLength: 18,
                          type: "number",
                          min: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "form_title" }, [_vm._v("添加接收部门")]),
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            { attrs: { span: 8 } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "",
                    "label-col": { span: 2 },
                    "wrapper-col": { span: 22 },
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      on: { change: _vm.reSetData },
                      model: {
                        value: _vm.deptName,
                        callback: function ($$v) {
                          _vm.deptName = $$v
                        },
                        expression: "deptName",
                      },
                    },
                    [
                      _vm.navSwitch === 0
                        ? _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v(" 经理部 "),
                          ])
                        : _vm._e(),
                      _vm.navSwitch === 0 || _vm.navSwitch === 1
                        ? _c("a-radio", { attrs: { value: 2 } }, [
                            _vm._v(" 经销商 "),
                          ])
                        : _vm._e(),
                      _vm.navSwitch === 2 && _vm.index != 0
                        ? _c("a-radio", { attrs: { value: 3 } }, [
                            _vm._v(" 销售顾问 "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tool_bar" },
        [
          _vm.navSwitch === 0 || _vm.navSwitch === 1
            ? _c(
                "vxe-button",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "100px",
                    top: "40px",
                    "z-index": "999",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.download(2)
                    },
                  },
                },
                [_vm._v("部门导入模板下载 ")]
              )
            : _vm._e(),
          _vm.navSwitch === 2
            ? _c(
                "vxe-button",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "100px",
                    top: "40px",
                    "z-index": "999",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.download(1)
                    },
                  },
                },
                [_vm._v("人员导入模板下载 ")]
              )
            : _vm._e(),
          _c(
            "a-upload",
            {
              attrs: {
                name: "file",
                multiple: false,
                accept: ".xlsx",
                action: _vm.api,
                headers: { token: _vm.token },
              },
              on: { change: _vm.importHandleChange },
            },
            [
              _c(
                "vxe-button",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "20px",
                    top: "40px",
                    "z-index": "999",
                  },
                },
                [_vm._v("导入")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { forceRender: true, tab: "" } },
            [
              _vm.hasLoaded
                ? _c("managerProp", {
                    ref: "managerProp",
                    attrs: {
                      rowId: _vm.rowId,
                      navSwitch: _vm.navSwitch,
                      deptId: _vm.deptId,
                      tabsFlag: _vm.deptName,
                    },
                    on: { setTable: _vm.setTable },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }